import * as Yup from 'yup';

const toOptionalNumber = (schema: Yup.NumberSchema<number | undefined>) =>
  schema.transform((val, orig) => {
    return orig === '' || orig === null || typeof orig === 'undefined'
      ? undefined
      : val;
  });

const requiredText = () => Yup.string().trim().required('Required');

const requiredNumber = () =>
  toOptionalNumber(
    Yup.number().typeError('Invalid Number').required('Required')
  );

export const bankersRowSchema = () =>
  Yup.object({
    branchName: requiredText(),
    isMain: Yup.boolean().required('Required'),
    isAgency: Yup.boolean().required('Required'),
    employeeNumber: requiredNumber(),
    underwritingYear: requiredNumber(),
    infedility: requiredNumber(),
    burglary: requiredNumber(),
    holdup: requiredNumber(),
    inSafe: requiredNumber(),
    inTransit: requiredNumber(),
    forgedCheques: requiredNumber(),
    counterfeitCurrencies: requiredNumber(),
    clause6: requiredNumber(),
    falsification: requiredNumber()
  });

/** Form-level schema */
export const bankersValidationSchema = () =>
  Yup.object({
    bankerDetails: Yup.array() // ✅ CHANGED: bankersDetails → bankerDetails
      .of(bankersRowSchema())
      .min(1, 'At least one row is required')
  });
